export const LOCALES = {
    ENGLISH: "en-US",
    DEUTSCH: "de-de"
};